import { render } from "./StartTips.vue?vue&type=template&id=3e2d6cc2&scoped=true"
import script from "./StartTips.vue?vue&type=script&lang=js"
export * from "./StartTips.vue?vue&type=script&lang=js"

import "./StartTips.vue?vue&type=style&index=0&id=3e2d6cc2&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e2d6cc2"]])

export default __exports__